import IdGenerator from 'scripts/domain/contracts/id_generator';

import TeamAssistMessage from 'models/team_assist_message';

export default class AskTeamAssist {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, question }) {
    if (!customerId) {
      return;
    }
    if (!question) {
      return;
    }

    if (!this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const { teamAssists } = this.context.stores.customers.storesFor(customerId);

    const messageId = IdGenerator.newId();
    const optimisticMessage = TeamAssistMessage.create({
      content: question,
      createdAt: new Date().toISOString(),
      customerId,
      id: messageId,
      role: TeamAssistMessage.Role.agent_question,
      type: TeamAssistMessage.Type.question,
    });
    teamAssists.addOrReplace(optimisticMessage);
    teamAssists.setLoading();

    this.context.gateways.teamAssist
      .add({ customerId }, { id: messageId, question })
      .catch(() => {
        teamAssists.remove(messageId);
      })
      .finally(() => {
        teamAssists.resetLoading();
      });
  }
}
